import {Button, Input, Card, Loading, FormItem, Form, Icon, Notification, Message, MessageBox} from 'element-ui'
import VueProgressBar from 'vue-progressbar'
import ECharts from 'vue-echarts'
import "echarts"
import VueEllipseProgress from 'vue-ellipse-progress';

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    Vue.use(Icon)
    Vue.use(Button)
    Vue.use(Input)
    Vue.use(FormItem)
    Vue.use(Form)
    Vue.use(Card)
    Vue.use(VueProgressBar, {
      color: "rgb(143, 255, 199)",
      failedColor: "red",
      height: "2px"
    })
    Vue.use(VueEllipseProgress)
    Vue.use(Loading.directive)
    Vue.component('v-chart', ECharts)
    Vue.prototype.$loading = Loading.service
    Vue.prototype.$notify = Notification
    Vue.prototype.$message = Message
    Vue.prototype.$confirm = MessageBox.confirm
  }
}

export default GlobalComponents
